export default __webpack_public_path__ + "static/media/noajust.3a5656ea.png";